module.exports = __webpack_public_path__ + "img/product_img02.f74cbf31.png";